import React from 'react';
import navbar from '../data/navbar.json';

const Images = ({data, className, style}) => {
    if(data == null){return (<div></div>);}
    if(data.data == null){return (<div></div>);}
    
    if(data.data.length > 0){
        return (
            <img src={data.data[0].attributes.url} alt={data.data[0].attributes.alternativeText} className={className} style={style}></img>
        )
    }
    else{
        if(data.data.attributes.url != null){
            return (
                <img src={data.data.attributes.url} alt={data.data.attributes.alternativeText} className={className} style={style}></img>
            )
        }
        else{
            return (
                <img src={navbar.data.attributes.navbar.img.data[0].attributes.url} alt={navbar.data.attributes.navbar.img.data[0].attributes.alternativeText} className={className} style={style}></img>
            )
        }
    }
}

export default Images;